export default __webpack_public_path__ + "static/media/foster_kinship_main.bc5c8001.jpg";